export const $urlImage = (url: string) => {
  return url.startsWith("http")
    ? url
    : url.startsWith("/")
      ? `${import.meta.env.VITE_MEDIA_URL}${url}`
      : `${import.meta.env.VITE_MEDIA_URL}/${url}`;
};
